import React from "react";
import { useAccess } from "../utils/useAccess"; // ✅ adjust path

export default function AccessGate({
  perm,
  mode = "any",
  roles,
  children,
  fallback = null,
}: {
  perm: string | string[];
  mode?: "any" | "all";
  /**
   * Optional extra role requirement, checked IN ADDITION to the permission —
   * not as an alternative to it. For the few actions where holding the
   * capability is not on its own enough, such as taking money on the
   * Institute's behalf, which asks for the capability AND an admin role.
   * Omit it and the gate behaves exactly as it always has.
   */
  roles?: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const { can } = useAccess();

  const permOk = can.allow(perm, mode);
  const roleOk =
    roles === undefined
      ? true
      : can.anyRole(Array.isArray(roles) ? roles : [roles]);

  if (!permOk || !roleOk) return <>{fallback}</>;
  return <>{children}</>;
}
